/**
 * MessageMarkdown — renders agent-authored message text (which the agent writes as light
 * markdown, e.g. `**Triage: general, minor priority**`) instead of showing the raw
 * asterisks. Same pipeline the lease wizard preview uses: marked -> DOMPurify ->
 * dangerouslySetInnerHTML. Only used for agent-authored bubbles; tenant/vendor/landlord text
 * stays plain (whitespace-preserved) so what they typed is shown verbatim.
 */

import { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export function MessageMarkdown({ content, className }: { content: string; className?: string }) {
  const html = useMemo(
    () => DOMPurify.sanitize(marked.parse(content, { async: false, breaks: true, gfm: true }) as string),
    [content],
  );
  return (
    <div
      className={
        'text-sm leading-relaxed [&_p]:m-0 [&_p+p]:mt-2 [&_ul]:my-1 [&_ul]:list-disc [&_ul]:pl-5 ' +
        '[&_ol]:my-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:font-bold [&_a]:underline ' +
        (className ?? '')
      }
      // Sanitized above.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
